import { fetchApi } from '@/config/axiosSetting.ts';
import { PostCulpritDamagedVehicleCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCulpritDamagedVehicleCorrectiveImages/postCulpritDamagedVehicleCorrectiveImages.type';
import { AxiosResponse } from 'axios';

export const postCulpritVehicleCorrectiveImagesFunction = ({
  body,
  id,
}: PostCulpritDamagedVehicleCorrectiveImagesType): Promise<
  AxiosResponse<any, any>
> => {
  return fetchApi({
    method: 'post',
    url: `/property/reports/${id}/accident_users/culprit/images/corrective/send/request/`,
    data: body,
  });
};
